import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { getUserError, getUserStatus } from "../store/slices/userSlice";
import { CSVLink } from "react-csv";
import $ from "jquery";
import "datatables.net";
import Modal from "react-modal";
import { blockUnblock, deleteAccount, getAllUsers, getStats } from "../store/featureActions";
import ImageViewer from "react-simple-image-viewer";
import { useNavigate } from "react-router-dom";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    width: "30%",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "0px",
    padding: "0px",
  },
};
Modal.setAppElement("#root");
const UserList = () => {
  const [id, setId] = useState();
  const dispatch = useDispatch();
  const [users, setUsers] = useState(null);
  const [stats, setStats] = useState(null);
  const status = useSelector(getUserStatus);
  const error = useSelector(getUserError);
  const [userDetail, setUserDetail] = useState(null);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState();
  const [modalImages, setmodalImages] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  console.log(status)
  console.log(error)
  const navigate = useNavigate()
  var csvData = [["Name", "Email", "Country", "Notification", "Verified"]];
  users?.map((item) => csvData.push([`${item?.name}`, `${item?.email}`, `${item?.country}`, `${item?.notification}`, `${item?.isVerified}`]));
  const openImageViewer = useCallback((images, index) => {
    setCurrentImage(index);
    setmodalImages(images);
  }, []);
  function viewModal(item, type) {
    setIsOpen(true);
    if (type == "userDetail") {
      setUserDetail(item);
    } else if (type == "seasonDetail") {
      quicStatsData(item?.ranking[0]?.seasonId?._id, item?._id);
      setUserDetail(item);
    } else if (type == "delete") {
      setId(item);
    }
    setModalType(type);
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
    setCurrentImage(0);
    setmodalImages(false);
  }

  const accountDelete = async (id) => {
    try {
      let payload = {
        params: id,
        isToast: true,
      };
      await dispatch(deleteAccount(payload)).unwrap();
      setIsOpen(false);
      $("#tableData").DataTable().destroy();
      try {
        Users();
      } catch (rejectedValueOrSerializedError) {
        console.log(rejectedValueOrSerializedError);
      }
    } catch (rejectedValueOrSerializedError) {
      console.log(rejectedValueOrSerializedError);
    }
  };

  const blockUnblockAccount = async (id) => {
    try {
      let payload = {
        params: id,
        isToast: true,
      };
      await dispatch(blockUnblock(payload)).unwrap();
      if (users) {
        $("#tableData").DataTable().destroy();
      }
      Users();
    } catch (rejectedValueOrSerializedError) {
      console.log(rejectedValueOrSerializedError);
    }
  };

  const Users = async () => {
    try {
      setUsers(null);
      let payload = {
        params: false,
        isToast: false,
      };
      const response = await dispatch(getAllUsers(payload)).unwrap();
      setUsers(response?.data?.Users);
    } catch (rejectedValueOrSerializedError) {
      console.log(rejectedValueOrSerializedError);
    }
  };

  const quicStatsData = async (seasonId, userId) => {
    try {
      setStats(null);
      let payload = {
        params: `?userId=${userId}&seasonId=${seasonId}`,
        isToast: false,
      };
      const response = await dispatch(getStats(payload)).unwrap();
      setStats(response?.data?.stats);
    } catch (rejectedValueOrSerializedError) {
      console.log(rejectedValueOrSerializedError);
    }
  };

  useEffect(() => {
    let mount = true;
    if (mount) {
      Users();
    }
    return () => {
      mount = false;
    };
  }, []);

  useEffect(() => {
    if (users) {
      $("#tableData").DataTable({
        lengthMenu: [10, 25, 50, 100, 200],
        language: {
          emptyTable: "Users Not Found",
        },
        destroy: true,
      });
    }
  }, [users]);

  return (
    <>
      <Modal closeTimeoutMS={500} isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles} contentLabel="Change Password">
        <div className="change-password-modal" id="exampleModalCenter" tabIndex={-1} aria-labelledby="exampleModalCenterTitle" aria-hidden="true" style={{ display: "block", zIndex: 100 }}>
          {modalType == "seasonDetail" ? (
            <>
              <p className="pass-text">Season Detail</p>
              <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              <div className="modal-body">
                <img src={userDetail?.imageName} />
                <p>Player name: {userDetail?.name ? userDetail?.name : "N/A"}</p>
                <p>Player id: {userDetail?.id ? `ReelRivals-${userDetail?.id}-${moment().format("YYYY")}` : "N/A"}</p>
                <p>Last Login: {userDetail?.lastLogin ? moment(userDetail?.lastLogin).local().format("YYYY-MM-DD hh:mm A") : "N/A"}</p>
                <p>Subscription: {userDetail?.packageType ? userDetail?.packageType : "N/A"}</p>
                <select onChange={(e) => quicStatsData(e.target?.value, userDetail?._id)}>
                  {userDetail?.ranking?.map((item, i) => {
                    return <option value={item?.seasonId?._id}>{item?.seasonId?.seasonName}</option>;
                  })}
                </select>
                <p>Rank: {stats?.rank ? "#" + stats?.rank : "#0"}</p>
                <p>PPH: {stats?.pph ? stats?.pph : 0}</p>
                <p>Total Catches: {stats?.totalCatchLogs ? stats?.totalCatchLogs : 0}</p>
                <p>One-on-One Win: {stats?.oneOnOneWinPercentage ? stats?.oneOnOneWinPercentage + "%" : 0 + "%"}</p>
                <p>Single Tournament Win: {stats?.singleWinPercentage ? stats?.singleWinPercentage + "%" : 0 + "%"}</p>
                <p>Team Tournament Win: {stats?.teamWinPercentage ? stats?.teamWinPercentage + "%" : 0 + "%"}</p>
              </div>
            </>
          ) : modalType == "userDetail" ? (
            <>
              <div className="headerModal">
                <p className="pass-text">User Detail</p>
                <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <p className="modal_inner_img" onClick={() => openImageViewer([userDetail?.imageName], 0)}>
                  <span>
                    <img height="20%" width="20%" style={{ borderRadius: 5 }} src={userDetail?.imageName ? `${userDetail?.imageName}` : "assets/images/placeholder.jpg"} />
                  </span>
                </p>
                <p className="user_detail">
                  <b>Name:</b> {userDetail?.name ? userDetail?.name : "N/A"}
                </p>
                <p className="user_detail">
                  <b>User Name:</b> {userDetail?.userName ? userDetail?.userName : "N/A"}
                </p>
                <p className="user_detail">
                  <b>Bio:</b> {userDetail?.bio ? userDetail?.bio : "N/A"}
                </p>
                <p className="user_detail">
                  <b>Device Type:</b> {userDetail?.user_device_type ?  userDetail.user_device_type.charAt(0).toUpperCase() + userDetail.user_device_type.slice(1) : "N/A"}
                </p>
                <p className="user_detail">
                  <b>Notification:</b> {userDetail?.notification.charAt(0).toUpperCase() + userDetail?.notification.slice(1)}
                </p>
                <p className="user_detail">
                  <b>Last Login:</b> {moment(userDetail?.lastLogin).local().format("MM-DD-YYYY hh:mm A")}
                </p>
              </div>
            </>
          ) : modalType == "delete" ? (
            <>
              <div className="headerModal">
                <p className="pass-text">Delete Account Confirmation</p>
                <button onClick={closeModal} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <form>
                  <div className="pass-form-wrap" style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
                    <div className="login-button mt-2" style={{ width: "40%" }}>
                      <button type="button" onClick={() => accountDelete(id)} style={{ backgroundColor: "rgba(0, 69, 139,0.8)" }} className="cta-btn col-reds w-100">
                        Delete
                      </button>
                    </div>
                    <div className="login-button mt-2" style={{ width: "40%" }}>
                      <button type="button" onClick={closeModal} style={{ backgroundColor: "rgba(0, 69, 139,0.8)" }} className="cta-btn col-reds w-100">
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </Modal>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          marginTop: users ? "1%" : "12%",
        }}
      >
        {/* <section className="excel-sec">
          <div className="container tableContainer">
            <div className=" mt-2 mb-3">
              {users ? (
                <button className="excel-btn col-reds w-10 pt-2 pb-2" style={{ backgroundColor: "rgba(0, 69, 139,0.8)" }}>
                  <CSVLink filename={"User List.csv"} data={csvData} style={{ textDecoration: "none" }}>
                    Export Excel
                  </CSVLink>
                </button>
              ) : (
                <></>
              )}
            </div>
          </div>
        </section> */}
        <section className="coupon-sec-2">
          <div className="container tableContainer">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="card shadow mb-4">
                  <div className="card-body">
                    <div className="table-responsive" id="tableready">
                      <table id="tableData" className="table table-bordered display" style={{ width: "100%", textAlign: "center" }}>
                        <thead>
                          {users ? (
                            <tr>
                              <th>S.No</th>
                              <th>Player Id</th>
                              <th>Name</th>
                              <th>User Name</th>
                              <th>Email</th>
                              <th>Joined date</th>
                              <th>Stats</th>
                              <th>Detail</th>
                              <th>Action</th>
                            </tr>
                          ) : (
                            <tr></tr>
                          )}
                        </thead>
                        <tbody>
                          {users?.map((item, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{`ReelRivals-${item?.id}-${moment().format("YYYY")}`}</td>
                              <td>{item?.name}</td>
                              <td>{item?.userName}</td>
                              <td>{item?.user_social_token ? "Social User" : item?.email}</td>
                              <td>{moment(item?.createdAt).format("DD-MMM-YYYY")}</td>
                              <td>
                                <span className="edit-icon">
                                  <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10, fontSize: 13 }} onClick={() => navigate("/quick-stats", { state: { item: item, type: "user" } })}>
                                    View
                                  </span>
                                </span>
                              </td>
                              <td>
                                <span className="edit-icon">
                                  <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10, fontSize: 13 }} onClick={() => viewModal(item, "userDetail")}>
                                    <i className="fas fa-eye"></i>
                                  </span>
                                </span>
                              </td>
                              <td>
                                <span className="edit-icon">
                                  <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10 }} onClick={() => viewModal(item?._id, "delete")}>
                                    <i className="fas fa-trash-alt"></i> Delete
                                  </span>
                                  <span style={{ cursor: "pointer", fontWeight: "bold", margin: 10 }} onClick={() => blockUnblockAccount(item?._id)}>
                                    {item?.block ? <i className="fa fa-unlock-alt"> UnBlock</i> : <i className="fa fa-solid fa-ban"> Block</i>}
                                  </span>
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        {!users ? (
                          status == "loading" || error ? (
                            <tfoot>
                              <tr>
                                <th>{status == "loading" ? "Loading..." : error ? error : ""}</th>
                              </tr>
                            </tfoot>
                          ) : (
                            <></>
                          )
                        ) : (
                          <></>
                        )}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {modalImages && (
          <ImageViewer
            src={modalImages}
            currentIndex={currentImage}
            onClose={closeModal}
            disableScroll={true}
            backgroundStyle={{
              backgroundColor: "rgba(0,0,0,0.9)",
              zIndex: 3,
            }}
            closeOnClickOutside={true}
            showPrevButton={currentImage > 0}
          />
        )}
      </div>
    </>
  );
};
export default UserList;
